import { useState, useEffect, useRef, forwardRef } from "react";
import { renderToString /*,renderToStaticMarkup*/ } from "react-dom/server";
import { HashLink } from "react-router-hash-link";
import $ from "jquery";

import { useBooleanFlagValue } from "@openfeature/react-sdk";
import flags from "../featureFlags/flags";
// import convert from 'xml-js';
import { ContentSection, ChildContent } from "./contentsection";
import { ContentDate } from "./contentdate";
import { isPregnancyBreastfeedingIndex } from "../../utils/pregnancyPageUtils";
import { transformDrugCategoriesToCollapsible } from "../DrugCategories";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import {
  getAuthToken,
  fetchMap,
  selectAuth,
  selectMap,
  selectValue,
  selectCache,
  selectVersion,
  selectMPSTopicFile,
  selectDitaPath,
  selectXRefPath,
  selectUXPlatform,
  selectUQueryString,
  selectFetchQueue,
  selectC5State,
  fetchContent,
  iDBMap,
  selectReferenceFiles,
  selectDefaultPath,
  resetDefaultPath,
  iDBContent,
  selectOpenSection,
  selectDisplayBanner,
  selectMedium,
  updateState,
  selectHeadTitle,
  selectHashRedirect,
  selectID,
  selectZip,
  selectiDB,
  selectIP,
  selectActiveTopicHRefSearchPath,
  selectExpired,
  selectIsModernView,
  fetchContentAsync,
} from "./counterSlice.js";

import { HandleTOCClick, UpdateURL } from "./updateURL";
import { setTabClickLock } from "../../features/tableOfContents/TableOfContentsSlice";
import { rxhtmltag4jQuery } from "./rxhtmltag";
import { getUrlObj, removeSpecialCharacters, hasAtLeastOneWord } from "../../utils";
import PrepareToView from "./prepareToView";
import useAppModernisation from "../../hooks/useAppModernisation";
import useToast from "../../hooks/useToast";
import style from "./Counter.module.scss";
import classNames from "classnames";
import { isScrollable } from "../../utils/isScrollable";
import getSelectedActiveTablesFigures from "../../utils/getSelectedActiveTableFigures";
import { retrieveDescriptions, xrefSet } from "./pbXmlContentParser";
import { extractFilenameWithHash } from "../../utils/formatters/createUrlFromDitaFilename";

rxhtmltag4jQuery();

const Counter = forwardRef(({ setReferencePopup, setIsCalculator, setCalculatorType }, ref) => {
  const navigationType = useNavigationType();
  const isEnhancedBrowserHistoryButton = useBooleanFlagValue(
    flags.ENHANCED_BROWSER_HISTORY_BUTTON,
    false,
  );
  const { pathname, search } = useLocation();
  const [mainEffect, setMainEffect] = useState(0);
  const { isModernView, isMobileView, isWebModernisationEnabled } = useAppModernisation();
  const toast = useToast();

  const searchParams = new URLSearchParams(search);
  const glPage = searchParams.get("guidelinePage") || "";
  const tpFile = searchParams.get("topicfile");
  let mainEffectTimer = setTimeout(() => {}, 500); // required to initiate and track.
  let dartSelectors = {};
  dartSelectors.auth = useSelector(selectAuth);
  dartSelectors.map = useSelector(selectMap);
  dartSelectors.value = useSelector(selectValue);
  dartSelectors.cache = useSelector(selectCache);
  dartSelectors.openSection = useSelector(selectOpenSection);
  dartSelectors.ditapath = useSelector(selectDitaPath);
  dartSelectors.XRefPath = useSelector(selectXRefPath);
  dartSelectors.C5State = useSelector(selectC5State);
  dartSelectors.activeTopicHRefSearchPath = useSelector(selectActiveTopicHRefSearchPath);
  dartSelectors.ip = useSelector(selectIP);
  dartSelectors.uxPlatform = useSelector(selectUXPlatform);
  dartSelectors.queryString = useSelector(selectUQueryString);
  dartSelectors.defaultPath = useSelector(selectDefaultPath);
  dartSelectors.fetchQueue = useSelector(selectFetchQueue);
  dartSelectors.referenceFiles = useSelector(selectReferenceFiles);
  dartSelectors.dispatch = useDispatch();
  dartSelectors.location = useLocation();
  dartSelectors.navigate = useNavigate();
  dartSelectors.ccmsversion = useSelector(selectVersion);
  dartSelectors.mpstopicfile = useSelector(selectMPSTopicFile);
  dartSelectors.displayBanner = useSelector(selectDisplayBanner);
  dartSelectors.medium = useSelector(selectMedium);
  dartSelectors.headTitle = useSelector(selectHeadTitle);
  dartSelectors.hashRedirect = useSelector(selectHashRedirect);
  dartSelectors.authID = useSelector(selectID);
  dartSelectors.zip = useSelector(selectZip);
  dartSelectors.iDB = useSelector(selectiDB);
  dartSelectors.isModernView = useSelector(selectIsModernView);
  const prevBannerClass = useRef(null);
  // const syntheticReplaceRef = useRef(false);
  const sub_expired = useSelector(selectExpired);

  useEffect(() => {
    //[] GetAuthToken from SP
    // console.log(67,"counter.js",'useEffect [] GetAuthToken');
    dartSelectors.dispatch(getAuthToken({ dartSelectors }));
    if (dartSelectors.uxPlatform === "mobile") {
      // console.log(70,"counter.js",window.parent.location.href);
      // console.log(71,"counter.js",window.location.href);
    }

    // console.log(dartSelectors.ccmsversion.selected);
    // localforage.config({name: dartSelectors.ccmsversion.selected+"_"+dartSelectors.ditapath});
    // dartSelectors.iDB.config({ name: dartSelectors.ccmsversion.selected });
    if (dartSelectors.ccmsversion?.selected === "main-123") {
      dartSelectors.iDB.clear().then(() => {
        console.log("iDB cleared for main");
      });
    }

    if (dartSelectors.uxPlatform === "mobile") {
      console.log(95, "counter.js", "tracking back button");
      $(".backicon").off();
      $(".backicon").on({
        click: function () {
          console.log(96, "counter.js", "backbutton-clicked");
        },
      });
    }
  }, []);

  useEffect(() => {
    // $('.slider-arrow').off('click');
    if (pathname.includes("viewTopic") || pathname.includes("topicTeaser")) {
      if (!tpFile) {
        dartSelectors.dispatch(updateState({ headTitle: "" }));
        setTimeout(() => {
          const searchParams = new URLSearchParams(search);
          const guidelinePage = searchParams.get("guidelinePage");
          if (guidelinePage !== "quicklinks") {
            $("#etgGuidelineBox").css("display", "block");

            if (prevBannerClass.current) {
              $(".guideline-box").removeClass(prevBannerClass.current);
            }

            $(".guideline-box").addClass(
              dartSelectors.mpstopicfile[dartSelectors.ditapath.replace("/", "")]?.bannerclass +
                "-gl",
            );
            prevBannerClass.current =
              dartSelectors.mpstopicfile[dartSelectors.ditapath.replace("/", "")]?.bannerclass +
              "-gl";
          } else {
            $("#etgGuidelineBox").css("display", "none");
          }
        }, 1000);
      }

      $(window).on("resize scroll load", function () {
        let treeMenuWidth = $(".tree-menu").width() + 20;
        if (window.innerWidth > 360 && $(".slider-arrow").hasClass("show")) {
          $(".slider-arrow").css("left", "0px");
          $("#tocbox").css("left", -treeMenuWidth);
        } else if (window.innerWidth > 360 && $(".slider-arrow").hasClass("hide")) {
          $(".slider-arrow").css("left", "335px");
        } else if (window.innerWidth <= 360 && $(".slider-arrow").hasClass("show")) {
          $(".slider-arrow").css("left", "0px");
          $("#tocbox").css("left", -treeMenuWidth);
        } else if (window.innerWidth <= 360 && $(".slider-arrow").hasClass("hide")) {
          $(".slider-arrow").css("left", treeMenuWidth - 15);
        }
      });

      $(".slider-arrow")
        .off("click")
        .on("click", function (event) {
          let treeMenuWidth = $(".tree-menu").width() + 10;
          if ($(this).hasClass("show")) {
            if (window.innerWidth <= 380) {
              $("#tocbox").animate(
                {
                  left: "0px",
                },
                700,
                function () {},
              );

              $(".slider-arrow").animate(
                {
                  left: treeMenuWidth + "px",
                },
                700,
                function () {},
              );
            } else {
              $("#tocbox").animate(
                {
                  left: "0px",
                },
                700,
                function () {},
              );

              $(".slider-arrow").animate(
                {
                  left: "335px",
                },
                700,
                function () {},
              );
            }
            $(this).removeClass("show").addClass("hide");
          } else if ($(this).hasClass("hide")) {
            if (window.innerWidth <= 380) {
              $("#tocbox").animate(
                {
                  left: -treeMenuWidth + "px",
                },
                700,
                function () {},
              );

              $(".slider-arrow").animate(
                {
                  left: "0px",
                },
                700,
                function () {},
              );
            } else {
              $("#tocbox").animate(
                {
                  left: "-335px",
                },
                700,
                function () {},
              );
              $(".slider-arrow").animate(
                {
                  left: "0px",
                },
                700,
                function () {},
              );
            }
            $(this).removeClass("hide").addClass("show");
          }

          event.stopPropagation();
        });
    }
  }, [glPage, tpFile]);

  useEffect(() => {
    //[dartSelectors.auth,dartSelectors.ditapath]
    // console.log('useEffect dartSelectors.auth]');
    //Build TOC if auth token changes
    //TODO: Make path dynamic. Get from URL or enter default.
    // console.log(103,"counter.js","useeffect-ditapath");
    if (dartSelectors.auth !== 0) {
      let fileExtension = localStorage.getItem("dartbig") !== null ? "_x.txt" : ".txt";
      const guidelinePath = dartSelectors.ditapath.replaceAll("/", "") + fileExtension;

      // Read map from IndexedDB or fetch it from SP
      dartSelectors.iDB.read(guidelinePath).then((value) => {
        if (value) {
          console.log("Map from iDB", guidelinePath);
          dartSelectors.dispatch(iDBMap({ value, dartSelectors }));
        } else {
          console.log("Map from SP", guidelinePath);
          dartSelectors.dispatch(fetchMap({ path: guidelinePath, dartSelectors }));
        }
      });

      Object.keys(dartSelectors.referenceFiles).map((key, index) => {
        // console.log(dartSelectors.referenceFiles[key]);
        if (!key.includes("refContent"))
          // from counterslice.

          dartSelectors.iDB.read(dartSelectors.referenceFiles[key]).then((value) => {
            // console.log(dartSelectors.referenceFiles[key],value);
            if (value !== null) {
              dartSelectors.dispatch(
                iDBContent({
                  key: dartSelectors.referenceFiles[key],
                  value,
                }),
              );
            } else {
              dartSelectors.dispatch(
                fetchContent({
                  guideline: "",
                  topicFile: dartSelectors.referenceFiles[key],
                  dartSelectors,
                }),
              );
            }
          });
        return index;
      });
    }
  }, [
    dartSelectors.auth,
    dartSelectors.ditapath,
    dartSelectors.hashRedirect,
    dartSelectors.authID,
    dartSelectors.zip,
    sub_expired,
  ]);

  useEffect(() => {
    HandleTOCClick(dartSelectors, isEnhancedBrowserHistoryButton);
    if (dartSelectors.defaultPath !== "") {
      let defaultFile = extractFilenameWithHash(dartSelectors.defaultPath);
      UpdateURL(defaultFile, dartSelectors, "", true);
      dartSelectors.dispatch(resetDefaultPath(""));
    } else {
      if (tpFile) $('[href$="tables_and_figures"]').css("margin-left", "10px");
    }

    $("#tg_toc_id .tandf").addClass(localStorage.getItem("tnf"));

    $('[href="quicklinks/tandf"], [href="quicklinks/tables_and_figures"]').css("display", "none");
  }, [dartSelectors.map]);

  useEffect(() => {
    console.log("--isEnhancedBrowserHistoryButton", isEnhancedBrowserHistoryButton);
    if (!isEnhancedBrowserHistoryButton || navigationType !== "POP") return;
    if (dartSelectors.activeTopicHRefSearchPath?.length === 0) return;

    const { pathname, search, hash } = window.location;
    if (pathname !== "/viewTopic") return;

    const currentUrl = `${pathname}${search}${hash}`;
    const hrefStack = dartSelectors.activeTopicHRefSearchPath;

    const match = hrefStack
      .slice()
      .reverse()
      .find((entry) => entry?.mpsPath === currentUrl);

    if (match?.selectedTopicHref) {
      // syntheticReplaceRef.current = true;
      UpdateURL(match.selectedTopicHref, dartSelectors);
    }
  }, [
    isEnhancedBrowserHistoryButton,
    navigationType,
    dartSelectors.activeTopicHRefSearchPath,
    window.location.search,
    window.location.hash,
    window.location.pathname,
  ]);

  useEffect(() => {
    clearTimeout(mainEffectTimer);
    mainEffectTimer = setTimeout(
      () => {
        setMainEffect(mainEffect === 1 ? 0 : 1);
      },
      isModernView || mainEffect === 0 ? 500 : 1800,
    );

    if (dartSelectors.hashRedirect) {
      dartSelectors.dispatch(updateState({ hashRedirect: false }));
    }
  }, [
    dartSelectors.value,
    dartSelectors.location,
    dartSelectors.cache,
    dartSelectors.referenceFiles.refContent,
    dartSelectors.openSection,
    dartSelectors.XRefPath,
    dartSelectors.hashRedirect,
    dartSelectors.authID,
    dartSelectors.zip,
  ]);

  const buildContentSelector = (xrefPath) => {
    if (!xrefPath || !xrefPath.includes("#")) {
      return null;
    }

    let selector = xrefPath.replace(xrefPath.substring(0, xrefPath.indexOf(".dita") + 5), "");
    selector = selector.replace(/\//g, " #").replace(/\.\.\//g, "");

    // Handle table references
    if (selector.includes("-tbl")) {
      selector.split("#").forEach((segment) => {
        if (segment.includes("-tbl")) {
          selector = selector.replace("#" + segment, "#table-" + segment);
        }
      });
    }

    // Extract DIT index if present
    const ditInfo = {
      selector: selector,
      index: "",
    };

    if (selector.includes("|")) {
      const [mainSelector, index] = selector.split("|");
      ditInfo.selector = mainSelector + " indexterm";
      ditInfo.index = index;
    }

    // Fix undefined IDs
    if (selector.includes("#undefined ")) {
      selector = selector.replace("#undefined ", "");
      const fixedId = $(`#contentId ${selector}`).closest("concept,topic").attr("id");
      ditInfo.selector = `#${fixedId} ${selector}`;
    }

    return ditInfo;
  };

  const handleSectionVisibility = (paragraphId, paragraphIDPath, dartSelectors, ditIndex) => {
    if (!paragraphIDPath) return false;

    const openSection = dartSelectors.openSection.some((element) =>
      element.includes(paragraphIDPath),
    );

    if (!openSection) {
      try {
        const xrefBase = dartSelectors.XRefPath.split("#")[0];
        if (xrefBase !== paragraphIDPath && paragraphIDPath.indexOf(xrefBase) === -1) {
          UpdateURL(paragraphIDPath, dartSelectors, `${paragraphId}|${ditIndex}`);
          return true;
        }
      } catch (error) {
        console.log("Section visibility error:", error);
      }
    }
    return false;
  };

  const scrollTablefigure = (targetId) => {
    const el = document.querySelector(targetId) || document.getElementById(targetId);
    if (!el) return;

    // Scroll smoothly
    $(el).closest(":visible")[0]?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scroll_view = () => {
    // Lock the scroll-based TOC sync for the duration of the smooth scroll
    // animation so useScrollActiveTocItem cannot override the data-driven
    // active item while the page is animating toward its target position.
    setTabClickLock();
    if (search.includes("-tables-boxes-figures")) {
      console.log("---scroll_view---tables-boxes-figures");
      return;
    }
    const { selectedTableFigure, isTableFigure, targetId } = getSelectedActiveTablesFigures(
      dartSelectors.activeTopicHRefSearchPath,
    );
    const shouldScrollToTableOrFigure = selectedTableFigure?.includes(dartSelectors?.location.hash);
    if (
      shouldScrollToTableOrFigure &&
      dartSelectors.XRefPath &&
      selectedTableFigure &&
      targetId &&
      isTableFigure
    ) {
      scrollTablefigure(targetId);
      return;
    }
    let ditIndex = "";
    let paragraphID = "";
    let paragraphIDPath = "";
    let XRefPath = $("topicref.active:last").attr("href");
    // Not to show animation when click on pregnancy or breastfeeding button
    let isPopup = $(".dartmodal.active").length !== 0;

    if (dartSelectors.XRefPath) {
      XRefPath = dartSelectors.XRefPath;
    }

    if (XRefPath === undefined || XRefPath === "") {
      return;
    }

    let contentSection = `#contentId [filepath*="${XRefPath}"]`;

    if (XRefPath.includes("#")) {
      const contentInfo = buildContentSelector(XRefPath);

      if (contentInfo) {
        contentSection = contentInfo.selector;
        ditIndex = contentInfo.index;

        // Handle section visibility
        if (!XRefPath.includes("/") || XRefPath.includes(".dita")) {
          paragraphID = XRefPath.split("#")[1];
          if (paragraphID.includes("|")) {
            paragraphID = paragraphID.split("|")[0];
          }
          paragraphID = paragraphID.replace(/\//g, " #");

          paragraphIDPath = $(`#contentId #${paragraphID}`)
            .closest("section.showtandfsection")
            .find("[filepath]:eq(0)")
            .attr("filepath");

          if (paragraphIDPath === undefined) {
            const newParagraphID = paragraphID.includes("#")
              ? paragraphID.split("#")[1]
              : paragraphID;
            const tryFilePath = $(`#contentId [filepath*="${newParagraphID}"]`)
              .closest("section")
              .find("[filepath]:eq(0)")
              .attr("filepath");

            if (tryFilePath) {
              paragraphIDPath = tryFilePath;
            }
          }

          handleSectionVisibility(paragraphID, paragraphIDPath, dartSelectors, ditIndex);

          // Handle missing content section
          const checkContentSection = $(`#contentId ${contentSection}`).length;
          if (checkContentSection === 0 && paragraphIDPath) {
            const newContentSection = `#contentId [filepath="${paragraphIDPath}"]`;
            const section = $(newContentSection).closest("section");
            let sectionContentPoint =
              section.find("concept:eq(0)").attr("id") || section.find("topic:eq(0)").attr("id");

            if (sectionContentPoint) {
              contentSection = `#contentId #${sectionContentPoint} indexterm`;
            }
          }
        }
      }
    }

    try {
      if (contentSection.includes("../")) {
        contentSection = contentSection.replace("../", "");
      }

      if (!contentSection.startsWith("#contentId")) {
        contentSection = "#contentId " + contentSection;
      }

      let targetElement;
      if (ditIndex) {
        targetElement = $(contentSection).eq(ditIndex).parent();
      } else {
        targetElement = $(contentSection);
        if (targetElement.length === 0 && contentSection.includes("#contentId #")) {
          const fallbackSelector = contentSection.replace("#contentId #", "");
          const checkFilePath = `#contentId [filepath*="${fallbackSelector}"]`;

          if ($(checkFilePath).length > 0) {
            const conceptId = $(checkFilePath)
              .closest("section")
              .find("concept:eq(0), topic:eq(0)")
              .attr("id");

            if (conceptId) {
              contentSection = `#contentId #${conceptId}`;
              targetElement = $(contentSection);
            }
          }
        }
      }

      // Handle mobile platform
      try {
        if (dartSelectors.uxPlatform === "mobile" && $("#menu-slide-button").offset().left > 0) {
          $("#menu-slide-button").trigger("click");
        }
      } catch (error) {
        console.log("Mobile platform error:", error);
      }

      // Perform scroll
      let uxScroll = $("html, body");
      if (isMobileView) {
        uxScroll = $("div.animated-route");
      } else if (isModernView) {
        uxScroll = $("div.webMode");

        if (!isScrollable(uxScroll)) {
          uxScroll = $("div.topicMainContent");
        }
      }

      if (XRefPath) {
        if (!isMobileView && targetElement && targetElement.length === 0) {
          setTimeout(() => {
            targetElement = $(contentSection.replace("filepath", "id"));
            if (targetElement.length === 0 && paragraphID) {
              let all_path_elements = XRefPath.split("#");
              let last_path_element = all_path_elements[all_path_elements.length - 1];
              targetElement = $(`#contentId [filepath*="${last_path_element.split("|")[0]}.dita"]`);
            }
            try {
              if (!isPopup && targetElement.length > 0) {
                setTabClickLock();
                $(targetElement[0])
                  .closest(":visible")[0]
                  ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            } catch (error) {
              console.log("Delayed scroll error:", error);
            }
          }, 1300);
        } else if (!XRefPath.includes("abg/c_abg16-c98-s2.dita#abg16-c98-s2/abg16-c98-box")) {
          if (isMobileView || isModernView) {
            function isDisplayed(element) {
              let current = element;
              while (current) {
                if (window.getComputedStyle(current).display === "none") {
                  return false;
                }
                current = current.parentElement;
              }
              return true;
            }
            const pureElement = targetElement[0];
            const firstType = [...document.querySelectorAll("h2")].find((el) => isDisplayed(el));

            if (
              firstType !== pureElement &&
              (isDisplayed(pureElement) || XRefPath.includes("topic_1.dita")) &&
              !isPopup
            ) {
              $(targetElement[0])
                .closest(":visible")[0]
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          } else if (!isPopup) {
            $(targetElement[0])
              .closest(":visible")[0]
              ?.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    } catch (error) {
      console.log("Scroll error:", error);
    }
  };

  useEffect(() => {
    const asyncFunction = async () => {
      let dateinfo = { published: "", amended: "" };
      let htmlContent = [];
      let firstReference = true;

      if ($("#etgGuidelineBox").length > 0 && tpFile === null) {
        setTimeout(() => {
          PrepareTeaser(dartSelectors, search);
        }, 1200);
        $("#contentId").css("display", "none");
        return;
      } else if ($("#etgGuidelineBox").length > 0 && tpFile !== null) {
        $("#contentId").css("display", "block");
        if (pathname.includes("viewTopic")) $("#etgGuidelineBox").css("display", "none");
      } else if ($(".topic-tools").length > 0) {
        //expert group container on /viewTopic
        if (pathname === "/topicTeaser/") {
          $(".topic-tools").css("display", "none");
        } else {
          setTimeout(() => {
            PrepareTeaser(dartSelectors, search);
          }, 100);
        }
      }
      setTimeout(() => {
        try {
          let guidelineFile = $('chapter[level="0"]').attr("href").split("/").splice(-1)[0];
          dartSelectors.iDB.read(guidelineFile).then((value) => {
            if (value) {
              // console.log(value);
              PrepareTopicToolsExpert(value, dartSelectors);
            } else {
              dartSelectors.dispatch(
                fetchContent({
                  guideline: dartSelectors.ditapath,
                  topicFile: guidelineFile,
                  dartSelectors,
                }),
              );
            }
          });
        } catch (error) {
          console.log(error);
        }
      }, 1200);

      if (dartSelectors.cache[dartSelectors.value[0]] !== undefined) {
        dartSelectors.value.forEach((filePath, index) => {
          // console.log("filePath>>>>>",filePath);
          let ditaContent,
            ditaTitle,
            children,
            level,
            previousTitle,
            headTitle,
            nextTitle,
            actualChildren = "";
          ditaContent = dartSelectors.cache[filePath].content;

          ditaTitle = dartSelectors.cache[filePath].title;
          children = parseInt(dartSelectors.cache[filePath].children);
          level = parseInt(dartSelectors.cache[filePath].level);
          previousTitle = "";
          actualChildren = $('[href="' + filePath + '"]').find("> topicref, > mapref").length;
          try {
            previousTitle = dartSelectors.cache[dartSelectors.value[index - 1]].title;
          } catch (e) {} // to manage failure of the first title.
          try {
            nextTitle = dartSelectors.cache[dartSelectors.value[index + 1]].title;
          } catch (e) {} // to manage failure of the last title.

          headTitle = $("#TOC_ID topicref.active")
            .closest('[href*=".ditamap"]')
            .find("ditatitle:eq(0)")
            .text()
            .replace("Addiction Medicine", "Addiction");
          if (headTitle === "") {
            headTitle = $("#TOC_ID chapter.active")
              .closest('[href*=".ditamap"]')
              .find("ditatitle:eq(0)")
              .text()
              .replace("Addiction Medicine", "Addiction");
          }

          if (isModernView && headTitle === "") {
            headTitle = dartSelectors.cache[dartSelectors.value[0]].title;
          }
          //if (filePath === dartSelectors.XRefPath) {
          if (
            dartSelectors.XRefPath.includes(filePath) ||
            (filePath.includes(dartSelectors.XRefPath.split("#")[0]) &&
              headTitle !== "" &&
              dartSelectors.XRefPath !== "")
          ) {
            dartSelectors.dispatch(updateState({ headTitle }));
            $(".etgtopic-banner-head").text(headTitle);
          }
          if (index === 0) {
            //banner/breadcrumb logic here
            if (dartSelectors.uxPlatform === "mobile") {
              if (filePath === dartSelectors.XRefPath) {
                $("#guideline-title h2").text(headTitle);
              }
              // $('#guideline-title h2',window.parent.document).text(headTitle);
              $("#guideline-title").css(
                "background-color",
                dartSelectors.mpstopicfile[dartSelectors.ditapath.replace("/", "")].mobheader,
              );
            }

            const cleanDitapath = removeSpecialCharacters(dartSelectors.ditapath);
            $(".topicbanner .banner-small")
              .removeClass()
              .addClass("banner-small")
              .addClass(dartSelectors.mpstopicfile[cleanDitapath.replace(/\//g, "")]?.bannerclass);

            $("#tocId .tree-menu>a").text(
              dartSelectors.mpstopicfile[cleanDitapath.replace(/\//g, "")]?.text,
            ); // above toc
          }
          let urlObj = getUrlObj();
          let addressURL = urlObj.href.replace(urlObj.protocol + "//" + urlObj.host, "");

          if (ditaTitle === "Indices") return {}; // ignore indices for how.
          // if(ditaTitle.indexOf("xRefs : ")===-1) // ignore content section fo xrefs

          if (
            children === 0 ||
            ditaTitle === nextTitle ||
            ditaTitle === "References" ||
            level > 3
          ) {
            // see counterslice  for level mgmt.
            // console.log("counterDartselectors>>>",dartSelectors);
            if (ditaTitle === "References" && firstReference === true) {
              firstReference = false;
              let renderedContent = renderToString(
                <ContentSection
                  title={ditaTitle}
                  dartSelectors={dartSelectors}
                  index={index}
                  length={actualChildren}
                  content={ditaContent}
                  filePath={filePath}
                  url={addressURL}
                  level={level}
                  isMobileView={isMobileView}
                  isModernView={isModernView}
                  guideline={dartSelectors.ditapath}
                />,
              );
              htmlContent.push(renderedContent);
              return {};
            }

            let contentToRender = ditaContent;
            let renderedContent = "";

            //if(contentToRender!=="")
            if (ditaTitle === nextTitle && children !== 0 && ditaTitle !== "References") {
              let renderedContent = renderToString(
                <ContentSection
                  title={ditaTitle}
                  dartSelectors={dartSelectors}
                  index={index}
                  length={actualChildren}
                  content={ditaContent}
                  filePath={filePath}
                  url={addressURL}
                  level={level}
                  isMobileView={isMobileView}
                  isModernView={isModernView}
                  guideline={dartSelectors.ditapath}
                />,
              );
              htmlContent.push(renderedContent);
            } else {
              let sameTitleCheck = ditaTitle === previousTitle ? true : false;
              renderedContent = renderToString(
                <ChildContent
                  title={ditaTitle}
                  level={level}
                  dartSelectors={dartSelectors}
                  content={contentToRender}
                  sameTitle={sameTitleCheck}
                  filePath={filePath}
                  url={addressURL}
                  isMobileView={isModernView}
                />,
              );
              let domContent = $("<body>").html(contentToRender);
              if (dateinfo.amended === "") {
                dateinfo.amended = $(domContent).find('[outputclass="docversion"]').text();
              }
            }

            let htmlContentMarker = htmlContent.length - 1;
            htmlContent[htmlContentMarker] = $("<body/>").html(htmlContent[htmlContentMarker]);

            $(htmlContent[htmlContentMarker]).find(".colapsecontent").append(renderedContent);

            htmlContent[htmlContentMarker] = $(htmlContent[htmlContentMarker]).html();
          } else {
            let domContent = $("<body>").html(ditaContent);
            let conceptId = $(domContent).find("concept:eq(0)").attr("id");
            let renderedContent = renderToString(
              <ContentSection
                conceptId={conceptId}
                title={ditaTitle}
                dartSelectors={dartSelectors}
                index={index}
                length={actualChildren}
                content={ditaContent}
                filePath={filePath}
                url={addressURL}
                level={level}
                isMobileView={isMobileView}
                isModernView={isModernView}
                guideline={dartSelectors.ditapath}
              />,
            );
            htmlContent.push(renderedContent);
          }
          return index;
        });
      }

      const contentDate = renderToString(
        <ContentDate published={dateinfo.published} amended={dateinfo.amended} />,
      );

      htmlContent.push(contentDate);

      let refPopupTitle = "";
      let refPopupContent = "";

      try {
        if (dartSelectors.cache.hasOwnProperty(dartSelectors.referenceFiles.refContent.file)) {
          refPopupTitle = dartSelectors.cache[dartSelectors.referenceFiles.refContent.file].title;
          refPopupContent =
            dartSelectors.cache[dartSelectors.referenceFiles.refContent.file].content;
        }
      } catch (error) {
        console.log("render reference", error);
      }

      const popContent = xmlReplace(refPopupContent, dartSelectors);
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(refPopupContent, "text/xml");

      // Find the note element and get its conref attribute
      const conref = xmlDoc.querySelector("note")?.getAttribute("conref");

      let conrefContent = "";

      if (conref) {
        const allConrefContent = await fetchContentAsync(
          dartSelectors,
          "",
          "quicklinks/" + conref.replace("../", ""),
        );
        // get the id after #
        const id = conref.split("#")[1].split("/")[1];
        const xml = parser.parseFromString(allConrefContent, "text/xml");
        conrefContent = new XMLSerializer().serializeToString(xml.getElementById(id));
      }

      if (popContent) {
        if (isWebModernisationEnabled) {
          let descriptionText = "";
          let dedupeXref = xrefSet(xmlDoc);
          const isMutiple = dedupeXref.length > 0 && typeof dedupeXref[0] === "object";

          const LINK =
            "/viewTopic?etgAccess=true&guidelinePage=quicklinks&topicfile=pbf&guidelinename=auto&sectionId=Classification_of_drug_use_while_breastfeeding_#Classification_of_drug_use_while_breastfeeding_";

          const isPregnancyFile = dartSelectors.referenceFiles.refContent.file.includes("g_p");
          const xref = isPregnancyFile ? xmlDoc.querySelector("xref")?.getAttribute("href") : null;

          if (isPregnancyFile && xref) {
            let baseUrl;
            let cleanedXref = xref.replace("../", "");

            if (xref.includes("pdf")) {
              baseUrl = "quicklinks/";
            } else if (xref.startsWith("../pbf/")) {
              baseUrl = "quicklinks/";
            } else {
              baseUrl = "quicklinks/glossary_topics/";
            }

            const pregnancyContent = await fetchContentAsync(
              dartSelectors,
              "",
              baseUrl + cleanedXref,
            );
            const pregnancyXml = parser.parseFromString(pregnancyContent, "text/xml");
            descriptionText = retrieveDescriptions(pregnancyXml);
          } else {
            descriptionText = retrieveDescriptions(xmlDoc);
          }
          setReferencePopup(
            <div className="dartmodal size-16 medium">
              <div className={isMobileView ? style.appPregnancyPopup : style.pregnancyPopup}>
                <div className={style.contentRow}>
                  <div className={classNames("bold", isMobileView && style.popupTitle)}>
                    {refPopupTitle}
                  </div>
                  <xref className={style.closeIcon} outputclass="closemodal">
                    <i className="tg-icons-Cross"></i>
                  </xref>
                </div>
                {dartSelectors.referenceFiles.refContent.file.includes("g_p") ? (
                  <div className={classNames(style.contentRow, style.compatibilitySection)}>
                    <div outputclass="tgl_preg"></div>
                    <div className={style.safetyText}>
                      Pregnancy safety: <b>{popContent}</b>
                    </div>
                  </div>
                ) : (
                  <div className={classNames(style.contentRow, style.compatibilitySection)}>
                    <div outputclass="tgl_breast"></div>
                    <div className={style.safetyText}>
                      Breastfeeding compatibility:{" "}
                      <>
                        {/* NEW LOGIC — text + href + <term> for multiple drugs*/}
                        {isMutiple && (
                          <div>
                            {dedupeXref.map(({ text, href }) => {
                              const keyref = href.replace(/^g_/, "").replace(".dita", "");

                              return (
                                <div key={href} className="breastfeeding-glossary__item">
                                  <span href={LINK}>
                                    <b>{text}</b>
                                  </span>

                                  <term
                                    keyref={keyref}
                                    outputclass="tgl_breast"
                                    class="- topic/term active"
                                    title="Check breastfeeding advice"
                                  />
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* OLD LOGIC — strings only, NO <term> */}
                        {!isMutiple && (
                          <div>
                            {dedupeXref.map((xref) => (
                              <div key={xref}>
                                <a href={LINK}>
                                  <b>{xref}</b>
                                </a>
                                <br />
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                )}
                <div className={classNames("size-14 light", style.contentRow, style.extraInfo)}>
                  {hasAtLeastOneWord(descriptionText) && (
                    <div dangerouslySetInnerHTML={{ __html: descriptionText }} />
                  )}
                  <div dangerouslySetInnerHTML={{ __html: conrefContent }}></div>
                </div>
              </div>
            </div>,
          );
        } else {
          setReferencePopup(
            <div className="dartmodal">
              <div className="dartmodalback"></div>
              <div
                className={
                  dartSelectors.uxPlatform === "mobile" ? "dartmodalboxmobile" : "dartmodalbox"
                }
              >
                <xref className="closemodal" outputclass="closemodal">
                  [X] Close
                </xref>
                <h4>{refPopupTitle}</h4>
                <div>{popContent}</div>
                <div dangerouslySetInnerHTML={{ __html: conrefContent }}></div>
              </div>
            </div>,
          );
        }
      }

      const sectionContent = $("#sectionContent");
      if (
        htmlContent.length > 1 ||
        htmlContent[0] !== '<div class="reviseddate" data-reactroot=""></div>' ||
        sectionContent.html() === "" ||
        dartSelectors.value.length === 0
      ) {
        sectionContent.html(htmlContent.join("</section><section>"));
      }

      PrepareToView(
        dateinfo,
        dartSelectors,
        tpFile,
        isMobileView,
        isModernView,
        toast,
        setReferencePopup,
        setIsCalculator,
        setCalculatorType,
        isWebModernisationEnabled,
      ); // see functions end of file.

      // Add collapsible functionality for pregnancy index pages AFTER PrepareToView processes content
      const searchParams = new URLSearchParams(search);
      const isPregnancyIndexPage = isPregnancyBreastfeedingIndex(searchParams, pathname);

      if (isPregnancyIndexPage) {
        // Transform drug categories to collapsible format
        transformDrugCategoriesToCollapsible(1500);
      }
      // Skip auto-scroll on browser back/forward (POP) so that
      // useScrollRestoration can restore the saved scroll position
      // without scroll_view fighting it via scrollIntoView().
      // Also skip on REPLACE because the "Enhanced Browser History"
      // effect fires a synthetic REPLACE right after a POP — running
      // scroll_view there would override the just-restored position.
      // EXCEPTION: in mobile view useScrollRestoration is disabled (the
      // .topicMainContent div isn't the actual scroll container on
      // mobile, the document is), so skipping scroll_view here would
      // strand the user without any scroll-to-anchor behavior at all.
      // const isSyntheticReplace = syntheticReplaceRef.current;
      // syntheticReplaceRef.current = false;

      // const skipScrollView =
      //   !isMobileView &&
      //   (navigationType === "POP" || (navigationType === "REPLACE" && isSyntheticReplace));
      // if (!skipScrollView) {
      //   setTimeout(scroll_view, 500);
      // }
      setTimeout(scroll_view, 500);
    };
    asyncFunction();
  }, [mainEffect]);

  return (
    <>
      <div className="qatools" id="C5State" style={{ display: "none" }}>
        {JSON.stringify({ ...dartSelectors.C5State, ip: dartSelectors.ip })}
      </div>
      <div ref={ref} dangerouslySetInnerHTML={{ __html: dartSelectors.map }}></div>
    </>
  );
}); // end of export Counter

let PrepareTeaser = (dartSelectors, search) => {
  if ($('chapter[level="0"]').length !== 1) {
    return; // Not ready to prepare teaser.
  }

  let guidelineFile = $('chapter[level="0"]').attr("href");
  if (guidelineFile === undefined) return;
  guidelineFile = guidelineFile.split("/").splice(-1)[0];

  dartSelectors.iDB.read(guidelineFile).then((value) => {
    if (value) {
      const ditaTitle = getDitatitle(value);
      if (ditaTitle) {
        dartSelectors.dispatch(updateState({ tocId: ditaTitle }));
      }

      const searchParams = new URLSearchParams(search);
      const guidelinePage = searchParams.get("guidelinePage");
      if (window.location.href.includes("topicTeaser")) {
        PrepareGuidelineBox(value, dartSelectors);
      } else if (window.location.href.includes("viewTopic") && guidelinePage !== "quicklinks") {
        PrepareTopicToolsExpert(value, dartSelectors);
        setTimeout(() => {
          // if($('.guideline-box').length > 0){
          if ($(".guideline-box").length > 0 && $("#etgGuidelineBox").length > 0) {
            PrepareGuidelineBox(value, dartSelectors);
          } else {
            // display HIDDEN guidelinebox with topicfile in URL to make expert modal functional
            $("#etgGuidelineBoxHidden").append(
              ' <div class="col-lg-6 col-md-6 col-sm-12 topiclist noLeftPaddingXs noRightPaddingXs boxstrnth"><div class="guideline-box mar-t32"></div></div>',
            );
            $("#contentId").css("display", "block");
            PrepareGuidelineBox(value, dartSelectors);
          }
        }, 500);
      }
    } else {
      dartSelectors.dispatch(
        fetchContent({
          guideline: dartSelectors.ditapath,
          topicFile: guidelineFile,
          dartSelectors,
        }),
      );
    }
  });
};

const getDitatitle = (value) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(value, "text/xml");
  const ditatitleVal = xmlDoc.querySelector("ditatitle")?.textContent;

  return ditatitleVal;
};

let PrepareGuidelineBox = (ditaValue, dartSelectors) => {
  //display in what's new section

  //console.log("dartSelectors", dartSelectors.ditapath);
  let uxGuidelineBox = $(".guideline-box");
  $(uxGuidelineBox).html(ditaValue);

  $(".guideline-box ditatitle").css("display", "none"); //hides the guideline name
  dartSelectors.ditapath = dartSelectors.ditapath?.replace(/\//g, "");

  //what's new link
  $('xref[format="pdf"]').text("What's New");
  let tgDate = $(".guideline-box ph").clone().children().remove().end().text(); //get the text/date beside "What's New"
  let newHTML = $(".guideline-box ph").html(); //retrieve the <ph> html

  if (dartSelectors.ditapath === "Palliative_Care") {
    newHTML = newHTML?.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/content-updates/palliativecare"',
    );
  } else if (dartSelectors.ditapath === "Rheumatology") {
    newHTML = newHTML?.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/content-updates/rheumatology"',
    );
  } else if (dartSelectors.ditapath === "Toxicology_and_Toxinology") {
    newHTML = newHTML?.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/content-updates/toxicologyandtoxinology"',
    );
  } else if (dartSelectors.ditapath === "Cardiovascular") {
    newHTML = newHTML?.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/content-updates/cardiovascular"',
    );
  } else if (dartSelectors.ditapath === "Psychotropic") {
    newHTML = newHTML?.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/content-updates/psychotropic/"',
    );
  } else if (dartSelectors.ditapath === "Antibiotic") {
    // console.log("Antibiotic before", newHTML);
    newHTML = newHTML?.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/products/therapeutic-guidelines/updates/antibiotic/"',
    );
  } else if (dartSelectors.ditapath === "Oral_and_Dental") {
    // console.log("Antibiotic before", newHTML);
    newHTML = newHTML.replace(
      /href="[^"]*"/,
      'href="https://www.tg.org.au/products/therapeutic-guidelines/updates/oral-and-dental/"',
    );
  }

  if (newHTML) {
    $(".guideline-box ph").html(newHTML.replace(tgDate, "")); //removes the date after "What's New"
  }

  //removing other texts on Declaration of interests
  $(".guideline-box linktext").text("Declaration of interests");
  let newSection = $(".guideline-box section").html();
  let newRelLinks = $(".guideline-box related-links").html();
  let getcodes = [];
  $(".guideline-box section").html(
    '<ul class="resource-list"><li>' +
      newSection +
      '</li><li class="contrib-list">Contributors</li></ul>',
  ); //moves related-links inside a list
  $(".contrib-list").append('<ul class="rel-links"></ul>'); //create an unordered list for contributor links
  $("related-links").remove(); //remove the original related-links

  //what's new on click event
  $('.resource-list xref[format="pdf"]').on({
    click: function () {
      let href = $(this).attr("href");
      let newHref = href.replace(
        "../",
        "https://ccmsfiles.tg.org.au/" + import.meta.env.REACT_APP_CCMS_VERSION + "/",
      );

      if (dartSelectors.ditapath === "Palliative_Care") {
        newHref = "https://www.tg.org.au/content-updates/palliativecare";
      } else if (dartSelectors.ditapath === "Rheumatology") {
        newHref = "https://www.tg.org.au/content-updates/rheumatology";
      } else if (dartSelectors.ditapath === "Toxicology_and_Toxinology") {
        newHref = "https://www.tg.org.au/content-updates/toxicologyandtoxinology";
      } else if (dartSelectors.ditapath === "Antibiotic") {
        newHref = "https://www.tg.org.au/products/therapeutic-guidelines/updates/antibiotic/";
      } else if (dartSelectors.ditapath === "Oral_and_Dental") {
        newHref = "https://www.tg.org.au/products/therapeutic-guidelines/updates/oral-and-dental/";
      }

      window.open(newHref);
    },
  });

  $(newRelLinks).each(function (index, element) {
    if (element.outerHTML !== undefined) {
      //check if the link outerHTML is not equal to undefined
      if (element.outerHTML.indexOf('format="pdf"') > -1) {
        getcodes.push('<li style="display:none">' + element.outerHTML + "</li>"); //pass the contributor links in an array, if the link is for the "Declaration of interest" it should be hidden
      } else {
        getcodes.push("<li>" + element.outerHTML + "</li>"); //pass the contributor links in an array, the text "Declaration of interest" displays
      }
    }
  });

  getcodes.forEach((element) => {
    //displays the related links in order
    if (element.includes("egm.dita")) $(".rel-links").prepend(element);
    else $(".rel-links").append(element);
  });

  // $('.guideline-box related-links link').each(function(index,element){
  $(".rel-links li link").each(function (index, element) {
    let guidelineboxlink = $(element).attr("href").replace("../", "");
    // console.log(guidelineboxlink);
    if (!guidelineboxlink.includes(".dita")) {
      // place the file URL to the link.
      $("linktext").on({
        click: function () {
          // $('link[href*="'+guidelineboxlink+'"]').trigger('click');
          //  console.log($('related-links link[format="pdf"]').attr('href'));
          window.open(
            `https://ccmsfiles.tg.org.au/${import.meta.env.REACT_APP_CCMS_VERSION}/` +
              guidelineboxlink,
          );
        },
      });
    } else {
      // console.log(guidelineboxlink)
      $('link[href*="' + guidelineboxlink + '"]').attr("data-toggle", "modal");
      $('link[href*="' + guidelineboxlink + '"]').css("display", "block");
      if (guidelineboxlink.toLowerCase().includes("acknowledgement")) {
        $('link[href*="' + guidelineboxlink + '"]').text("Acknowledgements");
        $('link[href*="' + guidelineboxlink + '"]').attr("data-target", "#acknowledgments");
        PrepareAcknowledgementExpertGroup(guidelineboxlink, dartSelectors, "acknowledgements");
      } else if (guidelineboxlink.includes("egm.dita")) {
        $('link[href*="' + guidelineboxlink + '"]').text("Expert group");
        $('link[href*="' + guidelineboxlink + '"]').attr("data-target", "#expertgroup");
        // $('.topicButtons .expertgroup').attr("href","../"+guidelineboxlink); // for expert group icon (conflict -- to be removed on next code cleanup)
        PrepareAcknowledgementExpertGroup(guidelineboxlink, dartSelectors, "expert");
      }

      $('link[data-target="#expertgroup"]').on({
        click: function () {
          let expertlink = $(this).attr("href").replace("../", "");
          PrepareAcknowledgementExpertGroup(expertlink, dartSelectors, "expert");
          $("#expertgroupId").css("display", "block");
          $("#expertgroupId ditatitle").css("font-size", "18px");
        },
      });

      $('link[data-target="#acknowledgments"]')
        .off()
        .on({
          click: function () {
            let acknowledgementlink = $(this).attr("href").replace("../", "");
            PrepareAcknowledgementExpertGroup(
              acknowledgementlink,
              dartSelectors,
              "acknowledgements",
            );
            $("#acknowledgmentId").css("display", "block");
          },
        });
    }
  });

  //Hiding guideline name inside guideline-box
  if ($(".guideline-box prolog").length === 1) {
    $(".guideline-box prolog").css("display", "none");
  }
};

let PrepareTopicToolsExpert = (ditaValue, dartSelectors) => {
  let ditaContainer = $(".ditaContent");
  $(ditaContainer).html(ditaValue);
  $(".ditaContent related-links link, #tg_toc_id related-links link").each(
    function (index, element) {
      let elemLink = $(element).attr("href").replace("../", "");
      // console.log(elemLink);
      if (elemLink.includes(".dita")) {
        if (elemLink.includes("egm.dita")) {
          $(".expertgroup").attr("href", elemLink);
          PrepareAcknowledgementExpertGroup(elemLink, dartSelectors, "expert");
        }
      }
    },
  );
};

let PrepareAcknowledgementExpertGroup = (ditapath, dartSelectors, section) => {
  // console.log(dartSelectors, "value123");
  dartSelectors.iDB.read(ditapath).then((value) => {
    if (value !== null) {
      value = $("<body />").html(value);
      console.log(value, ditapath, "value123");
      if (section === "acknowledgements") {
        $("#acknowledgmentId").html(value);
        $("#acknowledgmentId concept>ditatitle").css("display", "none");
        $("#acknowledgmentId>ditatitle").css("display", "none");
        $("#acknowledgmentId author").css("display", "none");
        $("#acknowledgmentId").css("display", "block");

        let waitforsourceexperts = setInterval(() => {
          if (
            dartSelectors.cache[dartSelectors.referenceFiles.source_experts] &&
            dartSelectors.cache[dartSelectors.referenceFiles.source_experts].content !== undefined
          ) {
            clearInterval(waitforsourceexperts);
            PrepareModalList("#acknowledgmentId", dartSelectors);
          }
        }, 100);
      } else if (section === "expert") {
        console.log(ditapath, "ditapath for expert");
        $("#expertgroupId").html(value);
        $("#expertgroupId concept>ditatitle").css("display", "none");
        $("#expertgroupId author").css("display", "none");

        let waitforsourceexperts = setInterval(() => {
          if (
            dartSelectors.cache[dartSelectors.referenceFiles.source_experts] &&
            dartSelectors.cache[dartSelectors.referenceFiles.source_experts].content !== undefined
          ) {
            clearInterval(waitforsourceexperts);
            PrepareModalList("#expertgroupId", dartSelectors);
          }
        }, 100);
      }
    } else {
      dartSelectors.dispatch(fetchContent({ guideline: "", topicFile: ditapath, dartSelectors }));
    }
  });
};

const PrepareSourceExperts = (content, hashTags, ditaURL) => {
  // console.log(hashTags,ditaURL);
  let newData = $("<body />").html(content);
  newData = $(newData)
    .find("#" + hashTags)
    .html();
  // console.log(newData);
  // console.log('[conref="'+ditaURL+'"]');
  $('[conref="' + ditaURL + '"]').html(newData);
};

const PrepareModalList = (ditaTag, dartSelectors) => {
  let source_experts = dartSelectors.cache[dartSelectors.referenceFiles.source_experts].content;
  $(ditaTag)
    .find("[conref]")
    .each(function (index, element) {
      let ditaURL = $(element).attr("conref");

      // console.log(ditaURL);
      if (ditaURL.includes("experts.dita")) {
        let ditapath = "Contributors/" + ditaURL.replace("../", ""); //add 'Contributors/' to the URL path
        let hashTags = ditapath.split("/").splice(-1)[0];
        ditapath = ditapath.split("#")[0];
        // console.log(source_experts);
        if (source_experts === "") {
          PrepareSourceExperts(source_experts, hashTags, ditaURL);
        } else
          dartSelectors.iDB.read(ditapath).then((content) => {
            // console.log(ditapath," - ",hashTags);
            if (content !== null) {
              source_experts = content;
              PrepareSourceExperts(content, hashTags, ditaURL);
            } else {
              dartSelectors.dispatch(
                fetchContent({
                  guideline: "",
                  topicFile: ditapath,
                  dartSelectors,
                }),
              );
            }
          });
      }
    });
};

const openLink = (dartSelectors, section) => {
  if (section.includes("../pbf")) {
    const newSection = section.replace("../", "");

    const data = {
      ditaPath: `quicklinks/`,
      queryString: {
        guidelinePage: "quicklinks",
        topicfile: "pbf",
        etgAccess: "true",
        guidelinename: "auto",
        sectionId: newSection.replace("pbf/", "").replace(".dita", ""),
      },
      openSection: newSection,
      displayBanner: false,
    };

    dartSelectors.dispatch(updateState(data));
    $(".dartmodal").toggleClass("active");
  } else {
    const data = {
      ditaPath: `quicklinks/`,
      queryString: {
        guidelinePage: "quicklinks",
        topicfile: "pbf",
        etgAccess: "true",
        guidelinename: "auto",
        sectionId: section,
      },
      openSection: section,
      displayBanner: false,
    };

    dartSelectors.dispatch(updateState(data));
    $(".dartmodal").toggleClass("active");
  }
};

function xmlToJson(xmlString) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  const traverseNode = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      return {
        type: "element",
        name: node.nodeName,
        attributes: Array.from(node.attributes).reduce(
          (acc, attr) => ({ ...acc, [attr.name]: attr.value }),
          {},
        ),
        elements: Array.from(node.childNodes)
          .map(traverseNode)
          .filter((n) => n),
      };
    } else if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
      return { type: "text", text: node.textContent.trim() };
    }
  };

  const doctype = xmlDoc.doctype;
  const elements = [
    doctype
      ? {
          type: "doctype",
          doctype: `${doctype.name} PUBLIC "${doctype.publicId}" "${doctype.systemId}"`,
        }
      : null,
    traverseNode(xmlDoc.documentElement),
  ].filter((e) => e);

  return { elements };
}

const xmlReplace = (xmlValue, dartSelectors) => {
  // console.log(xmlValue);
  if (xmlValue) {
    const convertedVal = xmlToJson(xmlValue); //convert.xml2js(xmlValue);
    // console.log(convertedVal);
    if (convertedVal && Object.entries(convertedVal).length > 0) {
      const elements = [];
      let jsx;
      Object.entries(convertedVal).forEach(([key, value]) => {
        value.forEach((val) => {
          if (val.type === "element" && val.name === "glossentry") {
            val.elements.forEach((ele) => {
              if (ele.name === "glossterm") {
                elements.push(
                  <div className={`${ele.attributes.class}`} key={`${ele.name}-${key}`}></div>,
                );
              }

              if (ele.name === "glossdef") {
                const children = [];
                ele.elements.forEach((el) => {
                  if (el.name === "xref") {
                    handleXref(el, children, dartSelectors);
                  } else if (el.name === "p") {
                    el.elements?.forEach((child, idx) => {
                      if (child.name === "xref" && child.attributes?.href?.startsWith("g_p_")) {
                        const hrefAttr = child.attributes.href;

                        const ditapath = hrefAttr.replace("g_p_", "").replace(".dita", "");

                        const text = child.elements?.find((e) => e.text)?.text || "";

                        const keyref = `p_${ditapath}`;

                        children.push(
                          <div key={`preg-${ditapath}`} className="pregnancy-glossary__item">
                            <span
                              className={classNames(
                                "pregnancy-glossary__label",
                                child.attributes?.class,
                              )}
                            >
                              {text}
                            </span>

                            <term
                              keyref={keyref}
                              outputclass="tgl_preg"
                              className={classNames(
                                "- topic/term active",
                                "pregnancy-glossary__indicator",
                              )}
                              title="Check pregnancy categorisation"
                            />
                          </div>,
                        );

                        return;
                      } else {
                        handleXref(child, children, dartSelectors);
                      }
                    });
                  }
                });
                elements.push(
                  <div className={`${ele.attributes.class}`} key={`${ele.name}`}>
                    {children}
                  </div>,
                );
              }
            });

            jsx = <div key="glossentry">{elements}</div>;
          }
        });
      });

      return jsx ? jsx : null;
    }
  }

  return null;
};

function handleXref(el, children, dartSelectors) {
  let ditapath;
  let text = "";
  if (el.attributes?.href && el.attributes.href?.indexOf("pbf/") > -1) {
    el.elements.forEach((lastChild) => {
      if (lastChild.text) {
        text = lastChild.text;
      }
    });
    ditapath = el.attributes.href.replace("../pbf/", "").replace(".dita", "");
    const href = `/viewTopic/?etgAccess=true&guidelinePage=quicklinks&topicfile=pbf&guidelinename=auto&sectionId=${ditapath}#${ditapath}`;
    children.push(
      <>
        <HashLink
          to={`${href}`}
          className={`${el.attributes.class}`}
          key="xref"
          onClick={() => openLink(dartSelectors, el.attributes.href)}
        >
          {text}
        </HashLink>
        <br />
      </>,
    );
  }
}

export default Counter;
